import "./TransportsListing.css";
import React, { Fragment } from "react";
import { Link } from "react-router-dom";
import TransportListingViewModel from "./TransportsListingViewModel";
import ActionConfirmation from "../../../../Components/ActionConfirmation/ActionConfirmation";
import { PulseLoader } from "react-spinners";
import { ToastContainer } from "react-toastify";
import NoDataFound from "../../../../Components/NoDataFound/NoDataFound";

const TransportsListing = () => {
  const {
    DeleteDialog,
    handleOpenDeleteDialog,
    handleCloseDeleteDialog,
    TransportsArray,
    IsLoading,
  } = TransportListingViewModel();
  return (
    <Fragment>
      {/* Page Wrapper */}
      <div className="page-wrapper admin-add-transport-page">
        <div className="content container-fluid">
          {/* Page Header */}
          <div className="page-header">
            <div className="row align-items-center">
              <div className="col">
                <h3 className="page-title">Transport</h3>
                <ul className="breadcrumb">
                  <li className="breadcrumb-item">
                    <a href="#">Dashboard</a>
                  </li>
                  <li className="breadcrumb-item active">Transport</li>
                </ul>
              </div>
            </div>
          </div>
          {/* /Page Header */}
          <div className="row">
            <div className="col-sm-12">
              <div className="card card-table">
                <div className="card-body">
                  {/* Page Header */}
                  <div className="page-header">
                    <div className="row align-items-center">
                      <div className="col">
                        <h3 className="page-title">Transport</h3>
                      </div>
                      <div className="col-auto text-end float-end ms-auto download-grp">
                        <Link
                          to={`/user/admin/transport/add`}
                          className="btn btn-primary"
                        >
                          <i className="fas fa-plus" />
                        </Link>
                      </div>
                    </div>
                  </div>
                  {/* /Page Header */}
                  {IsLoading ? (
                    <PulseLoader
                      style={{
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "center",
                      }}
                      color="#3D5EE1"
                      size={16}
                    />
                  ) : (
                    <div className="table-responsive">
                      <table className="table border-0 star-student table-hover table-center mb-0 datatable table-striped">
                        <thead className="student-thread">
                          <tr>
                            <th>Route Name</th>
                            <th>Vehicle Number</th>
                            <th>Driver Name</th>
                            <th>Driver License</th>
                            <th>Contact Number</th>
                            <th>Driver Address</th>
                            <th className="text-end">Action</th>
                          </tr>
                        </thead>
                        <tbody>
                          {TransportsArray &&
                            TransportsArray.map((item, index) => {
                              return (
                                <tr key={index}>
                                  <td>{item?.RouteName}</td>
                                  <td>{item?.VehicleNumber}</td>
                                  <td>{item?.DriverName}</td>
                                  <td>{item?.DriverLicense}</td>
                                  <td>{item?.ContactNumber}</td>
                                  <td>{item?.DriverAddress}</td>
                                  <td className="text-end">
                                    <div className="actions ">
                                      <Link
                                        onClick={() => {
                                          handleOpenDeleteDialog(item?.id);
                                        }}
                                        className="btn btn-sm bg-success-light me-2 "
                                      >
                                        <i className="fa-regular fa-trash-can"></i>
                                      </Link>
                                      <Link
                                        to={`/user/admin/transport/update/${item?.id}`}
                                        className="btn btn-sm bg-danger-light"
                                      >
                                        <i className="fa-regular fa-pen-to-square"></i>
                                      </Link>
                                    </div>
                                  </td>
                                </tr>
                              );
                            })}
                        </tbody>
                      </table>
                    </div>
                  )}
                  {TransportsArray?.length <= 0 && <NoDataFound />}
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      {/* /Page Wrapper */}

      <ActionConfirmation
        title={"Delete Confirmation"}
        description={"Are you sure you want to delete this transport?"}
        openDialog={DeleteDialog}
        handleCloseDialog={handleCloseDeleteDialog}
      />

      <ToastContainer />
    </Fragment>
  );
};

export default TransportsListing;
